var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSlider',{attrs:{"adsorb":true,"data":_vm.speedData,"tooltip":'none',"tooltip-placement":'bottom'},on:{"change":_vm.selectAndEmit},model:{value:(_vm.internalSelected),callback:function ($$v) {_vm.internalSelected=$$v},expression:"internalSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }